export const ZIP_CODE_REG_EXP = /(^[a-zA-Z0-9]+$)/;
export const NAME_REG_EXP = /(^[a-zA-Z\s]+$)/;

export enum KycFormFlag {
  init = 'INIT',
  yes = 'YES',
  no = 'NO',
}

export enum Countries {
  usa = 'USA',
  canada = 'CANADA',
}
